
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'VolumesBuyersHeader'
})
export default class extends Vue {
}
